<ng-container
  *ngrxLet="installationFeaturesStore.selectUpdateFeatureLoading$ as selectUpdateFeatureLoading"
>
  <ng-container
    *ngrxLet="installationDetailsStore.installationAddressInfo$ as installationAddressInfo"
  >
    <div class="setting-container" [class.disabled]="selectUpdateFeatureLoading">
      <div class="setting-optimization">
        <div class="grid grid-cols-2 gap-4">
          <div class="flex flex-col">
            <p class="text-[18px] font-normal">
              {{ '+HEMS.SETTINGS.OPTIMIZATION.SELF_CONSUMPTION_OPTIMIZATION_TITLE' | translate }}
            </p>
            <span class="text-[14px]">{{
              '+HEMS.SETTINGS.OPTIMIZATION.SELF_CONSUMPTION_OPTIMIZATION_DESCRIPTION' | translate
            }}</span>
          </div>
          <ng-container
            *ngrxLet="
              installationFeaturesStore.isSelfConsumptionOptimization$ as isSelfConsumptionOptimization
            "
          >
            <div class="xs:text-center sm:text-center">
              {{
                isSelfConsumptionOptimization
                  ? ('GENERAL.ON' | translate)
                  : ('GENERAL.OFF' | translate)
              }}
            </div>
          </ng-container>
        </div>
        <ng-container
          *ngIf="installationAddressInfo.country?.toLowerCase() === assistantSupportedLanguages.de"
        >
          <div *ngIf="featureTariffBasedFinancialOptimizationState">
            <div class="mb-[16px]">
              <app-optimization-setting-option
                [checked]="featureTariffBasedFinancialOptimizationState?.properties?.active?.value"
                [title]="'+HEMS.SETTINGS.OPTIMIZATION.TARIFF_TITLE' | translate"
                [description]="'+HEMS.SETTINGS.OPTIMIZATION.TARIFF_DESCRIPTION' | translate"
                [disabledToggle]="
                  selectUpdateFeatureLoading ||
                  !(
                    featureTariffBasedFinancialOptimizationState
                    | executable: featureCommands.setActive
                  )
                "
                (toggleChange)="
                  onTariffBasedFinancialOptimizationChange(
                    $event,
                    featureTariffBasedFinancialOptimizationState
                  )
                "
                [isShowPill]="true"
                [isSubscriptionActive]="
                  featureTariffBasedFinancialOptimizationState?.properties?.subscriptionActive
                    ?.value
                "
              ></app-optimization-setting-option>
            </div>

            <ng-container
              *ngIf="
                featureAllowBatteryChargingFromTheGrid &&
                featureTariffBasedFinancialOptimizationState?.properties?.active?.value
              "
            >
              <div class="mb-[16px]">
                <app-optimization-setting-option
                  [checked]="featureAllowBatteryChargingFromTheGrid?.properties?.active?.value"
                  [title]="'+HEMS.SETTINGS.OPTIMIZATION.BATTERY_CHARGING_TITLE' | translate"
                  [description]="
                    '+HEMS.SETTINGS.OPTIMIZATION.BATTERY_CHARGING_DESCRIPTION' | translate
                  "
                  (toggleChange)="
                    onActivateDeactivateFeature(
                      $event,
                      featureAllowBatteryChargingFromTheGrid,
                      'Battery charging from the grid change'
                    )
                  "
                  [isShowPill]="true"
                  [isSubscriptionActive]="
                    featureTariffBasedFinancialOptimizationState?.properties?.subscriptionActive
                      ?.value
                  "
                  [disabledToggle]="
                    selectUpdateFeatureLoading ||
                    !isForecastBasedActive ||
                    (featureAllowBatteryChargingFromTheGrid.properties?.active?.value
                      ? !(
                          featureAllowBatteryChargingFromTheGrid
                          | executable: featureCommands.deactivate
                        )
                      : !(
                          featureAllowBatteryChargingFromTheGrid
                          | executable: featureCommands.activate
                        ))
                  "
                ></app-optimization-setting-option>
              </div>

              <app-banner type="info" *ngIf="!featureForecastBased?.properties?.active?.value">{{
                '+HEMS.SETTINGS.OPTIMIZATIONS.TARIFF_BASED_FINANCIAL_OPTIMIZATION.BATTERY_OFF.NOTIFICATION'
                  | translate
              }}</app-banner>
            </ng-container>

            <app-banner
              type="info"
              *ngIf="
                !featureTariffBasedFinancialOptimizationState?.properties?.tariffsActive?.value &&
                featureTariffBasedFinancialOptimizationState?.properties?.subscriptionActive?.value
              "
              >{{
                '+HEMS.SETTINGS.OPTIMIZATIONS.TARIFF_BASED_FINANCIAL_OPTIMIZATION.TARIFFS_ACTIVE.EXPLAINATION.FALSE_TEXT'
                  | translate
              }}</app-banner
            >

            <app-banner
              type="info"
              *ngIf="
                !featureTariffBasedFinancialOptimizationState?.properties?.subscriptionActive?.value
              "
              >{{
                '+HEMS.SETTINGS.OPTIMIZATIONS.TARIFF_BASED_FINANCIAL_OPTIMIZATION.SUBSCRIPTION_ACTIVE.EXPLAINATION.FALSE_TEXT'
                  | translate
              }}</app-banner
            >
          </div>

          <p>{{ '+HEMS.SETTING.OPTIMIZATION.EMS_TITLE' | translate }}</p>

          <a
            data-at-go-to-ems-tool
            target="_blank"
            href="https://emstool.viessmann-climatesolutions.com/"
            class="ems-tool flex flex-row justify-start items-center gap-1 w-fit"
            gtm="onOpen"
            gtmAction="Go to EMS Tool"
            gtmCategory="hems"
          >
            <span class="ems-tool__title">{{
              '+HEMS.SETTING.OPTIMIZATION.EMS_BUTTON' | translate
            }}</span>
            <mat-icon class="ems-tool__icon">arrow_forward</mat-icon>
          </a>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-container>
